<script setup>
/**
 * Verkoop-productpagina. Bootstrap (labels, USPs) komt uit PHP.
 * Verhuur blijft in features/product/.
 */
import VerhuurProductPage from '@verhuur/product/ProductPageApp.vue';
</script>

<template>
  <div class="vsb-verkoop-product">
    <VerhuurProductPage />
  </div>
</template>

<style scoped>
.vsb-verkoop-product :deep(.vsb-product-page__breadcrumb a:hover) {
  color: #004494;
}
.vsb-verkoop-product :deep(.vsb-product-page__title) {
  color: #004494;
  font-size: clamp(1.85rem, 4.4vw, 2.6rem);
}
.vsb-verkoop-product :deep(.vsb-product-page__features span) {
  color: #004494;
}
.vsb-verkoop-product :deep(.vsb-product-cart-item__title) {
  color: #004494;
}
.vsb-verkoop-product :deep(.vsb-product-cart-item__btn--primary) {
  background: #004494;
}
</style>
